import React from 'react';
import { Spin } from 'antd';
import s from './s.module.less';
import BannerContentItem from './BannerContentItem';
import {
    DataManager,
    TabDataManager,
    smartUpdateData,
} from '../../utils/dataUpdater';
import { TBannerMgmt } from '../../type';
import BannerContentModal from './BannerContentModal';
import { ServerMeta } from 'types/common';

type Props = {
    dataManager: DataManager;
    condition?: ServerMeta;
};

const BannerMgmt = ({ dataManager, condition }: Props) => {
    const [loading] = React.useState(false);
    const [contentModalVisible, setContentModalVisible] = React.useState(false);
    const [selectedBanner, setSelectedBanner] = React.useState<TBannerMgmt | undefined>(undefined);

    // 为bannerMgmt tab创建独立的数据管理器
    const [bannerTabManager] = React.useState<TabDataManager>(() => {
        return dataManager.createTabManager('bannerMgmt');
    });

    // 从tab数据管理器获取bannerMgmt数据
    const bannerMgmtData = bannerTabManager.getTabData('bannerMgmt');

    const handleBannerSave = async (data: TBannerMgmt) => {
        try {
            // 使用智能更新函数，只更新用户实际修改的字段
            const fieldsToUpdate: (keyof TBannerMgmt)[] = ['name', 'subText', 'callToActionName', 'callToActionLink'];
            smartUpdateData(bannerTabManager, data, bannerMgmtData, fieldsToUpdate);

            // 保存到服务器
            await dataManager.saveDataToServer(
                () => {
                    console.log('Banner saved successfully');
                    setContentModalVisible(false);
                    setSelectedBanner(undefined);
                },
                (error: any) => {
                    console.error('Failed to save banner:', error);
                },
            );
        } catch (error) {
            console.error('Error in handleBannerSave:', error);
        }
    };

    const handleContentEdit = () => {
        setSelectedBanner(bannerMgmtData);
        setContentModalVisible(true);
    };

    return (
        <div className={s.wrap}>
            <div className={s.title}>
                Banner management
            </div>

            <Spin spinning={loading}>
                <div className={s.contentSection}>
                    <BannerContentItem
                        banner={bannerMgmtData}
                        condition={condition}
                        onEdit={() => handleContentEdit()}
                    />
                </div>
            </Spin>

            {/* Banner Content Modal */}
            <BannerContentModal
                visible={contentModalVisible}
                onCancel={() => {
                    setContentModalVisible(false);
                    setSelectedBanner(undefined);
                }}
                onSave={handleBannerSave}
                initialData={selectedBanner}
                condition={condition}
            />
        </div>
    );
};

export default BannerMgmt;
